"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadChallenge = loadChallenge;
exports.loadChallengeStats = loadChallengeStats;
exports.challengeRegister = challengeRegister;
exports.loadUserChallenge = loadUserChallenge;
exports.loadUserGroupChallenge = loadUserGroupChallenge;
exports.updateUserChallenge = updateUserChallenge;
exports.loadUserChallengeActivities = loadUserChallengeActivities;
exports.loadUserChallengeActions = loadUserChallengeActions;
exports.loadUserGroupChallengeStats = loadUserGroupChallengeStats;
exports.watchLoadChallenge = watchLoadChallenge;
exports.watchLoadUserChallenge = watchLoadUserChallenge;
exports.watchUpdateUserChallenge = watchUpdateUserChallenge;
exports.watchRegisterChallenge = watchRegisterChallenge;
exports.watchLoadChallengeStats = watchLoadChallengeStats;
exports.watchLoadUserChallengeActivities = watchLoadUserChallengeActivities;
exports.watchLoadUserChallengeActions = watchLoadUserChallengeActions;
exports.watchLoadUserGroupChallenge = watchLoadUserGroupChallenge;
exports.watchLoadUserGroupChallengeStats = watchLoadUserGroupChallengeStats;
exports["default"] = exports.challengeSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _olyEngineUtils = require("@sportheroes/oly-engine-utils");

var _marked = _regeneratorRuntime2.mark(loadChallenge),
    _marked2 = _regeneratorRuntime2.mark(loadChallengeStats),
    _marked3 = _regeneratorRuntime2.mark(challengeRegister),
    _marked4 = _regeneratorRuntime2.mark(loadUserChallenge),
    _marked5 = _regeneratorRuntime2.mark(loadUserGroupChallenge),
    _marked6 = _regeneratorRuntime2.mark(updateUserChallenge),
    _marked7 = _regeneratorRuntime2.mark(loadUserChallengeActivities),
    _marked8 = _regeneratorRuntime2.mark(loadUserChallengeActions),
    _marked9 = _regeneratorRuntime2.mark(loadUserGroupChallengeStats),
    _marked10 = _regeneratorRuntime2.mark(watchLoadChallenge),
    _marked11 = _regeneratorRuntime2.mark(watchLoadUserChallenge),
    _marked12 = _regeneratorRuntime2.mark(watchUpdateUserChallenge),
    _marked13 = _regeneratorRuntime2.mark(watchRegisterChallenge),
    _marked14 = _regeneratorRuntime2.mark(watchLoadChallengeStats),
    _marked15 = _regeneratorRuntime2.mark(watchLoadUserChallengeActivities),
    _marked16 = _regeneratorRuntime2.mark(watchLoadUserChallengeActions),
    _marked17 = _regeneratorRuntime2.mark(watchLoadUserGroupChallenge),
    _marked18 = _regeneratorRuntime2.mark(watchLoadUserGroupChallengeStats);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function loadChallenge(apis, action) {
  var _action$payload, challengeId, clientId, language, defaultLanguage, data, convertedData;

  return _regenerator["default"].wrap(function loadChallenge$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, challengeId = _action$payload.challengeId, clientId = _action$payload.clientId, language = _action$payload.language, defaultLanguage = _action$payload.defaultLanguage;
          _context.prev = 1;
          _context.next = 4;
          return apis.challengeApi.getChallenge({
            challengeId: challengeId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context.sent;
          convertedData = _objectSpread({}, data, {
            display: _olyEngineUtils.displayUtils.getDisplayObjectValues({
              display: data.display,
              language: language,
              defaultLanguage: defaultLanguage
            })
          });
          _context.next = 8;
          return (0, _effects.put)(_actions["default"].loadChallengeSuccess(convertedData));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
          _context.next = 14;
          return (0, _effects.put)(_actions["default"].loadChallengeError());

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 10]]);
}

function loadChallengeStats(apis, action) {
  var _action$payload2, challengeId, clientId, groupId, globalCounter, requestParams, data;

  return _regenerator["default"].wrap(function loadChallengeStats$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload2 = action.payload, challengeId = _action$payload2.challengeId, clientId = _action$payload2.clientId, groupId = _action$payload2.groupId, globalCounter = _action$payload2.globalCounter;
          requestParams = {
            challengeId: challengeId,
            clientId: clientId
          };

          if (groupId) {
            requestParams.groupId = groupId;
          }

          if (globalCounter) {
            requestParams.globalCounter = globalCounter;
          }

          _context2.prev = 4;
          _context2.next = 7;
          return apis.challengeApi.getChallengeStatus(requestParams).then(function (p) {
            return p.request;
          });

        case 7:
          data = _context2.sent;
          _context2.next = 10;
          return (0, _effects.put)(_actions["default"].loadChallengeStatsSuccess(data));

        case 10:
          _context2.next = 16;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](4);
          _context2.next = 16;
          return (0, _effects.put)(_actions["default"].loadChallengeStatsError());

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[4, 12]]);
}

function challengeRegister(apis, action) {
  var _action$payload3, userId, clientId, challengeId, code, restart, groupId, payload;

  return _regenerator["default"].wrap(function challengeRegister$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload3 = action.payload, userId = _action$payload3.userId, clientId = _action$payload3.clientId, challengeId = _action$payload3.challengeId, code = _action$payload3.code, restart = _action$payload3.restart, groupId = _action$payload3.groupId;
          payload = {
            challenge: challengeId,
            restart: restart
          };

          if (groupId) {
            payload.group = groupId;
          }

          if (code) {
            payload.code = code;
          }

          _context3.prev = 4;

          if (!restart) {
            _context3.next = 10;
            break;
          }

          _context3.next = 8;
          return apis.userCoreApi.restartChallenge({
            userId: userId,
            clientId: clientId,
            challengeId: challengeId
          }).then(function (p) {
            return p.request;
          });

        case 8:
          _context3.next = 12;
          break;

        case 10:
          _context3.next = 12;
          return apis.userCoreApi.registerChallenge({
            userId: userId,
            clientId: clientId,
            payload: payload
          }).then(function (p) {
            return p.request;
          });

        case 12:
          _context3.next = 14;
          return (0, _effects.put)(_actions["default"].challengeRegisterSuccess());

        case 14:
          _context3.next = 16;
          return (0, _effects.put)(_actions["default"].loadUserChallenge({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }));

        case 16:
          _context3.next = 22;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3["catch"](4);
          _context3.next = 22;
          return (0, _effects.put)(_actions["default"].challengeRegisterError(_context3.t0));

        case 22:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[4, 18]]);
}

function loadUserChallenge(apis, action) {
  var _ref, challengeId, clientId, userId, data;

  return _regenerator["default"].wrap(function loadUserChallenge$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref = action.payload || {}, challengeId = _ref.challengeId, clientId = _ref.clientId, userId = _ref.userId;
          _context4.prev = 1;
          _context4.next = 4;
          return apis.userCoreApi.getUserChallenge({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context4.sent;
          _context4.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserChallengeSuccess(data));

        case 7:
          _context4.next = 13;
          break;

        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserChallengeError());

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 9]]);
}

function loadUserGroupChallenge(apis, action) {
  var _ref2, resourceType, resourceId, id, withMembers, data;

  return _regenerator["default"].wrap(function loadUserGroupChallenge$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _ref2 = action.payload || {}, resourceType = _ref2.resourceType, resourceId = _ref2.resourceId, id = _ref2.id, withMembers = _ref2.withMembers;
          _context5.prev = 1;
          _context5.next = 4;
          return apis.groupsApi.getOneResourceGroup({
            resourceType: resourceType,
            resourceId: resourceId,
            id: id,
            withMembers: withMembers
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context5.sent;
          _context5.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserGroupChallengeSuccess(data));

        case 7:
          _context5.next = 13;
          break;

        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserGroupChallengeError());

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 9]]);
}

function updateUserChallenge(apis, action) {
  var _action$payload4, challengeId, clientId, data, userId;

  return _regenerator["default"].wrap(function updateUserChallenge$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _action$payload4 = action.payload, challengeId = _action$payload4.challengeId, clientId = _action$payload4.clientId, data = _action$payload4.data, userId = _action$payload4.userId;
          _context6.prev = 1;
          _context6.next = 4;
          return apis.userCoreApi.updateUserChallenge({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId,
            data: data
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context6.next = 6;
          return (0, _effects.put)(_actions["default"].updateUserChallengeSuccess());

        case 6:
          _context6.next = 8;
          return (0, _effects.put)(_actions["default"].loadUserChallenge({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }));

        case 8:
          _context6.next = 14;
          break;

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6["catch"](1);
          _context6.next = 14;
          return (0, _effects.put)(_actions["default"].updateUserChallengeError());

        case 14:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 10]]);
}

function loadUserChallengeActivities(apis, action) {
  var _action$payload5, challengeId, clientId, userId, data;

  return _regenerator["default"].wrap(function loadUserChallengeActivities$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _action$payload5 = action.payload, challengeId = _action$payload5.challengeId, clientId = _action$payload5.clientId, userId = _action$payload5.userId;
          _context7.prev = 1;
          _context7.next = 4;
          return apis.userCoreApi.getUserChallengeActivities({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context7.sent;
          _context7.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserChallengeActivitiesSuccess(data));

        case 7:
          _context7.next = 13;
          break;

        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](1);
          _context7.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserChallengeActivitiesError());

        case 13:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[1, 9]]);
}

function loadUserChallengeActions(apis, action) {
  var _action$payload6, challengeId, clientId, userId, data;

  return _regenerator["default"].wrap(function loadUserChallengeActions$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _action$payload6 = action.payload, challengeId = _action$payload6.challengeId, clientId = _action$payload6.clientId, userId = _action$payload6.userId;
          _context8.prev = 1;
          _context8.next = 4;
          return apis.userCoreApi.getUserChallengeActions({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context8.sent;
          _context8.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserChallengeActionsSuccess(data));

        case 7:
          _context8.next = 13;
          break;

        case 9:
          _context8.prev = 9;
          _context8.t0 = _context8["catch"](1);
          _context8.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserChallengeActionsError());

        case 13:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[1, 9]]);
}

function loadUserGroupChallengeStats(apis, action) {
  var _action$payload7, challengeId, clientId, userId, data;

  return _regenerator["default"].wrap(function loadUserGroupChallengeStats$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _action$payload7 = action.payload, challengeId = _action$payload7.challengeId, clientId = _action$payload7.clientId, userId = _action$payload7.userId;
          _context9.prev = 1;
          _context9.next = 4;
          return apis.userCoreApi.getUserChallengeStats({
            challengeId: challengeId,
            clientId: clientId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context9.sent;
          _context9.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserGroupChallengeStatsSuccess(data));

        case 7:
          _context9.next = 13;
          break;

        case 9:
          _context9.prev = 9;
          _context9.t0 = _context9["catch"](1);
          _context9.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserGroupChallengeStatsError());

        case 13:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9, null, [[1, 9]]);
}

function watchLoadChallenge(apis) {
  return _regenerator["default"].wrap(function watchLoadChallenge$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadChallenge), loadChallenge, apis);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function watchLoadUserChallenge(apis) {
  return _regenerator["default"].wrap(function watchLoadUserChallenge$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserChallenge), loadUserChallenge, apis);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function watchUpdateUserChallenge(apis) {
  return _regenerator["default"].wrap(function watchUpdateUserChallenge$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].updateUserChallenge), updateUserChallenge, apis);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function watchRegisterChallenge(apis) {
  return _regenerator["default"].wrap(function watchRegisterChallenge$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].challengeRegister), challengeRegister, apis);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

function watchLoadChallengeStats(apis) {
  return _regenerator["default"].wrap(function watchLoadChallengeStats$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadChallengeStats), loadChallengeStats, apis);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}

function watchLoadUserChallengeActivities(apis) {
  return _regenerator["default"].wrap(function watchLoadUserChallengeActivities$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserChallengeActivities), loadUserChallengeActivities, apis);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}

function watchLoadUserChallengeActions(apis) {
  return _regenerator["default"].wrap(function watchLoadUserChallengeActions$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserChallengeActions), loadUserChallengeActions, apis);

        case 2:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked16);
}

function watchLoadUserGroupChallenge(apis) {
  return _regenerator["default"].wrap(function watchLoadUserGroupChallenge$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserGroupChallenge), loadUserGroupChallenge, apis);

        case 2:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked17);
}

function watchLoadUserGroupChallengeStats(apis) {
  return _regenerator["default"].wrap(function watchLoadUserGroupChallengeStats$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserGroupChallengeStats), loadUserGroupChallengeStats, apis);

        case 2:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked18);
}

var challengeSagas = function challengeSagas(apis) {
  return [(0, _effects.fork)(watchLoadChallenge, apis), (0, _effects.fork)(watchLoadUserChallenge, apis), (0, _effects.fork)(watchLoadUserGroupChallenge, apis), (0, _effects.fork)(watchRegisterChallenge, apis), (0, _effects.fork)(watchLoadChallengeStats, apis), (0, _effects.fork)(watchLoadUserChallengeActivities, apis), (0, _effects.fork)(watchLoadUserChallengeActions, apis), (0, _effects.fork)(watchUpdateUserChallenge, apis), (0, _effects.fork)(watchLoadUserGroupChallengeStats, apis)];
};

exports.challengeSagas = challengeSagas;
var _default = challengeSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map